import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useRobots } from "@/components/seo/Seo";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useLang } from "@/lib/i18n";

export default function TrackEntry() {
  const { t } = useLang();
  useRobots("noindex, nofollow");
  const navigate = useNavigate();
  const [code, setCode] = useState("");

  const go = (e) => {
    e.preventDefault();
    const clean = code.trim().toUpperCase();
    if (clean.length >= 4) navigate(`/suivi/${clean}`);
  };

  return (
    <div className="flex min-h-screen flex-col bg-gradient-to-b from-miles-ice/70 via-white to-white text-ink" data-testid="track-entry-page">
      <Navbar />
      <main className="flex flex-1 items-center">
        <div className="mx-auto w-full max-w-2xl px-5 py-28 sm:px-8">
          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}>
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-miles">{t("te.eyebrow")}</p>
            <h1 className="mt-5 text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl">
              {t("te.h1")}
            </h1>
            <p className="mt-4 max-w-md text-base leading-relaxed text-slate">{t("te.p")}</p>

            <form onSubmit={go} className="mt-9 flex flex-col gap-3 sm:flex-row" data-testid="track-entry-form">
              <input
                value={code}
                onChange={(e) => setCode(e.target.value.toUpperCase())}
                placeholder={t("te.ph")}
                data-testid="track-code-input"
                className="w-full rounded-2xl border border-ink/10 bg-white px-5 py-4 font-mono text-sm font-semibold uppercase tracking-[0.15em] text-ink outline-none transition-colors placeholder:text-slate/50 focus:border-miles focus:ring-4 focus:ring-miles/10"
              />
              <motion.button
                whileTap={{ scale: 0.97 }}
                type="submit"
                data-testid="track-code-submit"
                className="flex shrink-0 items-center justify-center gap-2 rounded-2xl bg-miles px-8 py-4 text-sm font-semibold text-white transition-colors duration-300 hover:bg-miles-dark"
              >
                {t("te.submit")} <ArrowRight className="h-4 w-4" strokeWidth={1.5} />
              </motion.button>
            </form>
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
